// removed by extract-text-webpack-plugin
module.exports = {"Information":"Information__Information__3qmOR","Book":"Information__Book__1sTcH","Back":"Information__Back__3BT69"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Schedule/Information/Information.css
// module id = 607
// module chunks = 0